import { Divider, Stack, Text, Title } from "@mantine/core";
import {
  useInstalledExtensions,
  extractParams,
} from "../../../../business/app-extensions.hook";
import { AppIframeHost } from "./AppIframeHost";

interface ExtensionPointRendererProps {
  pathname: string;
  title?: string;
}

export function ExtensionPointRenderer({
  pathname,
  title,
}: ExtensionPointRendererProps) {
  const { extensions, loading } = useInstalledExtensions(pathname);

  if (loading || extensions.length === 0) {
    return null;
  }

  return (
    <Stack gap="md">
      {title && (
        <>
          <Title order={5}>{title}</Title>
          <Divider />
        </>
      )}
      {extensions.map((ext) => {
        const matchedPattern = ext.extension.activePages.find((pattern) => {
          const patternParts = pattern.split("/");
          const pathParts = pathname.split("/");
          if (patternParts.length !== pathParts.length) return false;
          return patternParts.every(
            (part, i) => part.startsWith(":") || part === pathParts[i],
          );
        });

        const contextData = matchedPattern
          ? { ...extractParams(pathname, matchedPattern), pathname }
          : { pathname };

        return (
          <div key={`${ext.appId}-${ext.extension.type}`}>
            <Text size="xs" c="dimmed" mb={4}>
              {ext.appName}
            </Text>
            <AppIframeHost
              extensionCdnPath={ext.extensionCdnPath}
              appId={ext.appId}
              installationId={ext.installationId}
              grantedPermissions={ext.grantedPermissions}
              manifestNamespaces={ext.manifestNamespaces}
              extensionPoint={ext.extension.type}
              contextData={contextData}
              maxWidth={ext.extension.size?.maxWidth}
              maxHeight={ext.extension.size?.maxHeight}
            />
          </div>
        );
      })}
    </Stack>
  );
}
